import axios from 'axios';

// 產生一個專門用於後端 api 溝通的 axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_API_PATH,
    timeout: 20000,
});

// request 發送過濾器
service.interceptors.request.use(
    (config) => config,
    (error) => {
        Promise.reject(error);
    },
);

// response 接收過濾器
service.interceptors.response.use(
    (response) =>
        // 回傳成功 (200)
        response,
    (error) => Promise.reject(error),
);

export default service;
